import AmostrasService from "../../services/AmostrasService";
import { formatarTitleCase } from '../../shared/utils/Formatacao';
import { baixarArquivo } from "../../shared/utils/RequestUtil";

const tratarOpcoesFiltroTipos = (resultado) => {
    if (!resultado || !resultado.length)
        return [];

    resultado.forEach(item => item.descricao = formatarTitleCase(item.descricao));

    return resultado.sort((a, b) => a.descricao.localeCompare(b.descricao));
};

const formatarDadosAmostras = (amostras) => {
    if (!amostras || !amostras.length) return;

    amostras.forEach(am => {
        if (am.tipoAmostra)
            am.tipoAmostra.descricao = formatarTitleCase(am.tipoAmostra.descricao);
    });
};

class AmostrasManager {
    async listarAmostras(filtros, uuid) {
        return await AmostrasService.listarAmostras(filtros, uuid).then((res) => {
            const resultado = res && res.data;
            formatarDadosAmostras(resultado.itens);
            return resultado;
        })
    }

    async listarTipos() {
        return await AmostrasService.listarTipos().then((res) => {
            return res && tratarOpcoesFiltroTipos(res.data);
        })
    }

    async listarStatus() {
        return await AmostrasService.listarStatus().then((res) => {
            return res && res.data;
        })
    }

    async listarArquivos(idAmostra) {
        return await AmostrasService.listarArquivos(idAmostra).then((res) => {
            return res && res.data;
        })
    }

    async baixarArquivos(idAmostra, idArquivo, nomeArquivo) {
        const resposta = await AmostrasService.baixarArquivos(idAmostra, idArquivo);
        if (!resposta || !resposta.data) return;

        baixarArquivo(resposta, nomeArquivo);
    }

    async baixarPlanilha(operacoesListagem) {
        const resposta = await AmostrasService.baixarPlanilha(operacoesListagem);

        if (!resposta) return;

        return resposta;
    }
}

export default new AmostrasManager()